import { render, staticRenderFns } from "./toolbar.vue?vue&type=template&id=65da35d0&lang=pug&"
import script from "./toolbar.vue?vue&type=script&setup=true&lang=js&"
export * from "./toolbar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./toolbar.vue?vue&type=style&index=0&id=65da35d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports